import router from './router';
import store from './store';
import { getToken } from 'assets/js/auth';
import WaterMark from '@/assets/js/watermark.js';
import { pathPermission } from '@/utils/utils';
import moment from 'moment';
import Vue from 'vue';
const whiteList = ['/login']; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  const hasToken = getToken();
  if (hasToken) {
    if (to.path === '/login') {
      let redirect = to.query && to.query.redirect;
      redirect = redirect ? decodeURIComponent(redirect) : '';
      next({ path: redirect || '/' });
    } else {
      if (!store.getters.userInfo ) {
        await store.dispatch('user/getUserInfo').then(res => {
          Vue.prototype.$sentry.setUser({ id: store.getters.userInfo.id, username: store.getters.userInfo.nickname });
          Vue.prototype.$ga.setUserConfig(store.getters.userInfo.id);

        }).catch(err => {console.log(err);});
      }
      const permissions = [...store.getters.userInfo.permissions];
      let flag = pathPermission(permissions, to.path);
      WaterMark.set(store.getters.userInfo.nickname + ' ' + moment().format('YYYY-MM-DD'));
      if (flag) {
        next();
      } else {
        next({ path: '/403' });
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      let redirect = encodeURIComponent(location.pathname + location.search);
      next(`/login?redirect=${redirect}`);
    }
  }
});
